/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type ShannonPdfInfoStatus = (typeof ShannonPdfInfoStatus)[keyof typeof ShannonPdfInfoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShannonPdfInfoStatus = {
  queued: "queued",
  in_progress: "in_progress",
  finished: "finished",
  failed: "failed",
} as const;
